import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import VisitCardsAdminPage from "./VisitCardsAdminPage";

const UserProfile = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("token")) navigate("/login");
  }, [navigate]);

  return <VisitCardsAdminPage />;
};

export default UserProfile;
